<template>

<app-view-sheet-field :is-sticky="isSticky" :field="field" :filter="filter">

    <template v-if="value">{{ value }}</template>

</app-view-sheet-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky', 'isCondensed'],

	computed: {

		value: function() {

			return (this.item.collection && this.item.collection.condition) ? this.item.collection.condition : ''

		}

	}

}

</script>
